"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Mode;
(function (Mode) {
    Mode["Compact"] = "compact";
})(Mode || (Mode = {}));
exports.Mode = Mode;
//# sourceMappingURL=mode.js.map